<template>
  <OdoscopeSearch />
</template>

<script setup lang="ts">
defineOptions({ name: 'SearchPage' })
definePageMeta({ pageType: 'search_result_page' })
</script>
